import CommonCell from "./CommonCell"
import DateCell from "./DateCell"
import MoreOptions from "./MoreOptions"
import ReleaseUser from "./ReleaseUser"
import Status from "./Status"
import UserCell from "./UserCell"

const cells = {
  moreOptions: MoreOptions,
  userCell: UserCell,
  releaseUser: ReleaseUser,
  status: Status,
  date: DateCell,
  CommonCell: CommonCell
}

export default cells